import {useShowFavoriteStar} from '@rdcomponents/app/routing/helpers/menu-item-renderer';
import {NavigationItemConfigType} from '@rdcomponents/app/routing/routing-type';
import {MenuItemWithFavoriteStar} from '@rdcomponents/navigation/menu-item-with-favorite/menu-item-with-favorite';

type PropsType = {
    navigationConfigItem: NavigationItemConfigType;
};

/**
 * Label for custom menu items (e.g. Multichat, System status) that open an external resource via
 * `onClick` instead of navigating. When the item carries a (synthetic) path it becomes favoritable,
 * so we render the same favorite star as regular items; otherwise we fall back to the plain label.
 */
export function CustomMenuItemLabel({navigationConfigItem}: PropsType): JSX.Element {
    const {path, label, labelComponent} = navigationConfigItem;

    const showFavoriteStar = useShowFavoriteStar(navigationConfigItem);

    const baseLabel = labelComponent ?? label;

    if (showFavoriteStar && path) {
        return <MenuItemWithFavoriteStar childPaths={[]} label={baseLabel} path={path} />;
    }

    return <span>{baseLabel}</span>;
}
